module.exports = __webpack_public_path__ + "static/img/20220906105253.5e0cf19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/20220906105253.png
// module id = cBs1
// module chunks = 1